module.exports = __webpack_public_path__ + "static/img/img-1.3b232eb9.png";